import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { GlassCard, CustomInput, GradientButton, LoadingOverlay, useAlert } from '../../components';
import { redeemGiftCode } from '../../services/firestoreService';
import { formatCurrency } from '../../utils/helpers';
import './GiftCodeScreen.css';

export const GiftCodeScreen = () => {
    const navigate = useNavigate();
    const { refreshUserData } = useAuth();
    const alert = useAlert();
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);

    const handleRedeem = async () => {
        if (!code.trim()) {
            alert.showError('Error', 'Please enter a gift code');
            return;
        }

        setLoading(true);
        try {
            const amount = await redeemGiftCode(code.trim());
            await refreshUserData();
            alert.showSuccess(
                'Congratulations!',
                `You received ${formatCurrency(amount)} bonus!`,
                () => {
                    setCode('');
                    navigate(-1);
                }
            );
        } catch (error) {
            alert.showError('Error', error.message || 'Invalid or expired gift code');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="gift-code-screen">
            <LoadingOverlay visible={loading} message="Redeeming code..." />

            <div className="screen-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="screen-title">Gift Code</h1>
                <div style={{ width: 40 }}></div>
            </div>

            <div className="gift-illustration">
                <div className="gift-icon-container">
                    <span className="material-icons gift-icon">card_giftcard</span>
                </div>
                <h2>Redeem Gift Code</h2>
                <p>Enter your gift code below to receive bonus balance</p>
            </div>

            <GlassCard className="redeem-card">
                <CustomInput
                    label="Gift Code"
                    placeholder="Enter your gift code"
                    value={code}
                    onChange={(e) => setCode(e.target.value.toUpperCase())}
                    leftIcon="redeem"
                />

                <GradientButton
                    title="Redeem Code"
                    onClick={handleRedeem}
                    loading={loading}
                    disabled={!code.trim()}
                />
            </GlassCard>

            <div className="gift-info">
                <h4>How to get gift codes?</h4>
                <ul>
                    <li>Participate in special promotions</li>
                    <li>Follow our social media channels</li>
                    <li>Refer friends and earn rewards</li>
                    <li>Check announcements for giveaways</li>
                </ul>
            </div>
        </div>
    );
};

export default GiftCodeScreen;
